import { __assign } from 'tslib';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrandProvider } from '@shared-ui/brand-context';
import { UitkIcon } from 'uitk-react-icons';
import { UitkEGMapsScriptLoader } from '../components/uitk-eg-map-script-loader.esm.js';

/*
  This is a HOC that loads the google/mapbox JS api before rendering the child component that is passed as a parameter.
*/
var withScriptLoader = function (childComponent, props) {
    var _a, _b;
    var scriptLoaderProps = {
        accessToken: props.accessToken,
        googleMapsId: (_a = props.mapConfig) === null || _a === void 0 ? void 0 : _a.googleMapsId,
        locale: (_b = props.mapConfig) === null || _b === void 0 ? void 0 : _b.locale,
        mapType: props.mapType,
        mapTypeVersion: props.mapTypeVersion,
        width: props.width,
        height: props.height,
        reloadMapProviderSDK: props.reloadMapProviderSDK,
        onError: props.onError
    };
    return React.createElement(UitkEGMapsScriptLoader, __assign({}, scriptLoaderProps), childComponent);
};
/*
  This function takes icon name and brand as a parameter and renders the svg into a div
*/
var buildIcon = function (iconName, className, brand) {
    var icon = (React.createElement(BrandProvider, { config: brand },
        React.createElement(UitkIcon, { name: iconName, className: "".concat(className, " ").concat(iconName) })));
    var container = document.createElement('div');
    ReactDOM.render(icon, container);
    return container;
};
var buildMinipin = function () {
    var miniPinSvg = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "34", height: "28", viewBox: "0 0 34 28", fill: "none" },
        React.createElement("g", { filter: "url(#filter0_d_2814_28026)" },
            React.createElement("rect", { x: "8", y: "8", width: "18", height: "12", rx: "6", fill: "white" }),
            React.createElement("rect", { x: "8.5", y: "8.5", width: "17", height: "11", rx: "5.5", stroke: "#676A7C" })),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_2814_28026", x: "0", y: "0", width: "34", height: "28", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", null),
                React.createElement("feGaussianBlur", { stdDeviation: "4" }),
                React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.0470588 0 0 0 0 0.054902 0 0 0 0 0.109804 0 0 0 0.08 0" }),
                React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_2814_28026" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_2814_28026", result: "shape" })))));
    var container = document.createElement('div');
    ReactDOM.render(miniPinSvg, container);
    return container;
};

export { buildIcon, buildMinipin, withScriptLoader };
